import {
  CategoryStandardProduct,
  StandardOrderProduct,
} from "shared/api/middleware-api-client";
import Text from "shared/ui/typography/Text";

interface StandardProductConfigProps {
  standardProduct: CategoryStandardProduct | StandardOrderProduct;
}

const StandardProductConfig = ({
  standardProduct,
}: StandardProductConfigProps) => {
  return (
    <Text className="gg-mb-3 gg-text-sm">{standardProduct.description}</Text>
  );
};
export default StandardProductConfig;
